import { FC } from "react";
import LoaderSVG from "images/loader.svg";
import {
  StyledLoader,
  StyledLoaderBlurredContainer,
  StyledLoaderContainer,
} from "styles/components/loader";

interface LoaderProps {
  position?: string;
  transform?: string;
  top?: string;
  left?: string;
  bottom?: string;
  right?: string;
  width?: string;
  height?: string;
  margin?: string;
  className?: string;
  dataTestId?: string;
  withBlur?: boolean;
  whiteBlur?: boolean;
  fullPage?: boolean;
}

const Loader: FC<LoaderProps> = ({
  position,
  top,
  left,
  bottom,
  right,
  width,
  height,
  margin,
  transform,
  className,
  dataTestId,
  withBlur,
  whiteBlur,
  fullPage,
}) =>
  withBlur ? (
    <StyledLoaderBlurredContainer whiteBlur={whiteBlur} fullPage={fullPage}>
      <StyledLoaderContainer
        position="absolute"
        transform="translate(-50%, -50%)"
        top="50%"
        left="50%"
        width={width}
        height={height}
        margin={margin}
        className={className}
        data-testid={dataTestId}
      >
        <StyledLoader src={LoaderSVG} alt="loader" />
      </StyledLoaderContainer>
    </StyledLoaderBlurredContainer>
  ) : (
    <StyledLoaderContainer
      position={position}
      transform={transform}
      top={top}
      bottom={bottom}
      left={left}
      right={right}
      width={width}
      height={height}
      margin={margin}
      className={className}
      data-testid={dataTestId}
    >
      <StyledLoader src={LoaderSVG} alt="loader" />
    </StyledLoaderContainer>
  );

export default Loader;
